var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"max-width":"1500px"},attrs:{"fluid":"","grid-list-sm":""}},[_c('manual-config-panel',{on:{"management-button":_vm.onManagementButton}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }